import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";  // BrowserRouter is here
import App from "./App";
import { AppProvider } from "hooks/useApp";
import { DataProvider } from "hooks/useData";
import { ContextProvider } from "utilities/ContextProvider";
import { AuthProvider } from "react-oidc-context";
import { WebStorageStateStore } from "oidc-client-ts";
import { ScreenProvider } from "hooks/useScreen";
import { UnityProvider } from "hooks/UseUnity";
import { TabProvider } from "hooks/useAssetsActiveTab";
import { SceneProvider } from "hooks/useScene";
import { getExtractedPath, setExtractedPath } from "utilities/extractedPath";
import { MinifiedMenuItemsProvider } from "hooks/useMinifiedMenu";
import { UnityActionsProvider } from "hooks/unityActions";
import ModalProvider from "hooks/ModalProvider";
import { ProjectsCoordinatesProvider } from "hooks/CoordinatesContext";
import { FileUploadProvider } from "hooks/FilesUploadContext";
import { AiChatProvider } from "hooks/AiChatContext";
import { CoordinatesProvider } from "hooks/useCoordinates";
import { OrganizationProvider } from "hooks/OrganizationContext";
import { bootstrapStoredThemeColors, bootstrapStoredThemeMode } from "utilities/themeColors";

setExtractedPath();
bootstrapStoredThemeColors();
bootstrapStoredThemeMode();

const baseUrl = getExtractedPath();

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const oidcConfig = {
  client_id: `${process.env.REACT_APP_CLIENT_ID}`,
  client_secret: `${process.env.REACT_APP_CLIENT_SECRET}`,
  authority: `${process.env.REACT_APP_AUTH_APP}`,
  redirect_uri: `${process.env.REACT_APP_SAAS_APP}`,
  post_logout_redirect_uri: `${process.env.REACT_APP_SAAS_APP}`,
  scope: "openid",
  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  onSigninCallback: (user: any) => {
    window.history.replaceState(
      {},
      window.document.title,
      window.location.origin + window.location.pathname
    );
    window.location = user.state || "/";
  },
};

root.render(
  <React.StrictMode>
    <AuthProvider {...oidcConfig}>
    <OrganizationProvider>
    <CoordinatesProvider>
      <AppProvider>
        <FileUploadProvider>
          <SceneProvider>
            <UnityProvider>
              <TabProvider>
                <ScreenProvider>
                  <ModalProvider>
                    <DataProvider>
                      <MinifiedMenuItemsProvider>
                        <ProjectsCoordinatesProvider>
                          <UnityActionsProvider>
                            <ContextProvider>
                              <BrowserRouter basename={baseUrl}>
                                <AiChatProvider>
                                  <App />
                                </AiChatProvider>
                              </BrowserRouter>
                            </ContextProvider>
                          </UnityActionsProvider>
                        </ProjectsCoordinatesProvider>
                      </MinifiedMenuItemsProvider>
                    </DataProvider>
                  </ModalProvider>
                </ScreenProvider>
              </TabProvider>
            </UnityProvider>
          </SceneProvider>
        </FileUploadProvider>
      </AppProvider>
      </CoordinatesProvider>
      </OrganizationProvider>
    </AuthProvider>
  </React.StrictMode>
);

